import { AudioWaveform, Command, GalleryVerticalEnd } from 'lucide-react';
import { useMemo } from 'react';
import { NavMain } from '@/components/sidebar/nav-main';
import { TeamSwitcher } from '@/components/sidebar/team-switcher';
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
} from '@/components/ui/sidebar';
import {
  UsersThree,
  Users,
  Building,
  Crosshair,
  HouseLine,
  Insufficiency,
  Notebook,
  LinkSimple,
  UAN,
  Note,
  SubCompaniesIcon,
  VKYCIcon,
} from '@/assets/icons';
import { getAdminRoutes } from '@/router/AdminRoutes';
import pluralize from 'pluralize';
import { useSidebar } from '@/components/ui/sidebar';

const userData = JSON.parse(localStorage.getItem('user'));
const userEntityType = userData?.user?.entityType; // Get user entity type
const alias = userData?.bca?.configurations?.clientAlias || 'Client';

const pluralAlias = pluralize(alias);
const canSeeProducts =
  userData?.bca?.configurations?.verifies === 'EDDIndividual' &&
  userEntityType === 'BCA' &&
  userData?.isSuperAdmin === true;

const data = {
  teams: [
    { name: 'Acme Inc', logo: GalleryVerticalEnd, plan: 'Enterprise' },
    { name: 'Acme Corp.', logo: AudioWaveform, plan: 'Startup' },
    { name: 'Evil Corp.', logo: Command, plan: 'Free' },
  ],
  navMain: [
    {
      title: 'Dashboard',
      url: userEntityType === 'Vendor' ? '/vendor' : '/',
      icon: HouseLine,
      isActive: true,
    },
    {
      title: 'TAT & Priority',
      url: '/tat-priority',
      icon: Crosshair,
    },
    {
      title: 'Team',
      url: '/team',
      icon: UsersThree,
    },
    ...(canSeeProducts
      ? [
          {
            title: 'Product',
            url: '/products',
            icon: Notebook,
          },
        ]
      : []),
    {
      title: 'Candidate',
      url: '/candidate',
      icon: UsersThree,
    },
    {
      title: pluralAlias,
      url: '/companies',
      icon: Building,
    },
    {
      title: 'Cases',
      url: '/cases',
      icon: Users,
    },
    {
      title: 'Insufficiency',
      url: '/insufficiency',
      icon: Insufficiency,
    },
    {
      title: 'Sub-Branches',
      url: '/sub-companies',
      icon: SubCompaniesIcon,
    },
    {
      title: 'Tasks',
      url: '/tasks',
      icon: Notebook,
    },
    {
      title: 'Critical Task',
      url: '/critical-task',
      icon: Users,
    },
    {
      title: 'APIs',
      url: '/apis',
      icon: LinkSimple,
    },
    {
      title: 'Cases',
      url: '/client-cases',
      icon: Users,
    },
    {
      title: 'Case Activity',
      url: '/case-activity',
      icon: Note,
    },
    {
      title: 'UAN',
      url: '/uan-request',
      icon: UAN,
    },
    {
      title: 'Imposter Check',
      url: '/imposter-check',
      icon: VKYCIcon,
    },
  ],
};

export function AppSidebar({ ...props }) {
  const { state } = useSidebar();
  const isSidebarOpen = state === 'expanded';

  const allowedRoutes = useMemo(() => getAdminRoutes(), []);

  const filteredNav = useMemo(() => {
    return data.navMain.filter((navItem) =>
      allowedRoutes.some((route) => route.path === navItem.url),
    );
  }, [allowedRoutes]);

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarHeader
        className={`${isSidebarOpen ? 'p-0' : 'h-20 justify-center'}`}
      >
        <TeamSwitcher teams={data.teams} isSidebarOpen={isSidebarOpen} />
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={filteredNav} isSidebarOpen={isSidebarOpen} />
      </SidebarContent>
    </Sidebar>
  );
}
